export default __webpack_public_path__ + "3b06fe0b663922f804511239cb938987.jpg";